import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgba(252, 252, 252, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px 40px 32px 40px;
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

export const CloseModal = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const HeaderIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const SelectorOption = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  height: 42px;
  align-items: center;
  cursor: pointer;
  border-bottom: ${(props: { selected: boolean }) =>
    props.selected ? '2px solid rgba(110, 48, 232, 1)' : 'none'};
  width: 50%;
  justify-content: center;
  margin-bottom: 16px;
`;

export const SelectorText = styled.h2<{ selected: boolean }>`
  font-size: 16px;
  color: ${(props: { selected: boolean }) =>
    props.selected ? 'rgba(110, 48, 232, 1)' : '#4D4D4D'};
`;

export const Header2 = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const HeaderText = styled.h2`
  font-size: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  align-items: center;
  width: 100%;
  padding: 0 128px;
  height: 379px;
  border: 1px dashed rgba(148, 137, 255, 0.8);
`;

export const InputTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 201px;
`;

export const ImageWrapper = styled.div`
  min-width: 80px;
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InputTitle = styled.h2`
  font-size: 18px;
  color: rgba(77, 77, 77, 1);
`;

export const InputDescription = styled.p`
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
`;

export const InputMiddleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const InputMiddleLine = styled.div`
  width: 136px;
  height: 1px;
  background-color: rgba(153, 153, 153, 1);
`;

export const InputMiddleText = styled.h2`
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
`;

export const InputBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 920px;
  // height: 688px;
`;

export const ContentTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 24px;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
`;

export const InfosContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  height: 100%;
`;

export const InfosInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const DescriptionInput = styled.textarea`
  width: 100%;
  height: 200px;
  max-height: 500px;
  border: 0;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
  padding: 8px;
  background-color: rgba(252, 252, 252, 1);
  color: rgba(102, 102, 102, 1);
  padding-top: 8px;
  resize: none;
  &:focus {
    outline: none;
  }
`;

export const EmoteIconWrapper = styled.div`
  position: absolute;
  align-self: flex-end;
  bottom: 450px;
  top: 140px;
  gap: 8px;
  cursor: pointer;
  z-index: 1;
`;

export const LetterCounter = styled.p`
  font-size: 12px;
  color: rgba(153, 153, 153, 1);
  align-self: flex-end;
  // transition: 1s;
`;

export const TagsTitle = styled.h2`
  font-size: 14px;
  color: rgba(27, 27, 27, 1);
  cursor: pointer;
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 12px;
  column-gap: 8px;
`;

export const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(110, 48, 232, 1);
  border-radius: 8px;
  padding: 0px 4px;
  gap: 6px;
  font-size: 12px;
  font-family: Inter-Regular;
  width: fit-content;
`;

export const ProportionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: fit-content;
  background-color: #F5F5F5;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 8px;
`;

export const ProportionButton = styled.div<{ selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 40px;
  background-color: ${(props: { selected: boolean }) =>
    props.selected ? 'rgba(110, 48, 232, 1)' : ''};
  border-radius: 8px;
  cursor: pointer;
`;

export const ProportionInfo = styled.h2`
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
`;


export const ContentBottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ImageButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border: 3px solid rgba(110, 48, 232, 1);
  border-radius: 8px;
`;

export const DeleteButtonWrapper = styled.div`
  position: absolute;
  cursor: pointer;
  bottom: 84px;
  margin-right: -60px;
  // right: 30px;
  z-index: 20;
`;

export const AddImageButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border: 1px dashed rgba(148, 137, 255, 0.8);
  font-size: 10px;
  color: rgba(110, 48, 232, 1);
  gap: 8px;
  text-align: center;
  white-space: wrap;
  font-family: Inter-Bold;
`;